import { React } from "react";
import { Table, Skeleton } from "antd";
import {TableStyle} from "../../Pages/styledElements";

const TableShimmer = (props) => {
  const {
    showHeader,
    header,
    scroll,
    rows,
    minHeight,
    type
  } = props;

  const shimmerRows = rows ? rows : 10;

  return (
    (type == "PO Upload") ? (
      <TableStyle>
        <Table
          style={{minHeight: minHeight ? minHeight : "380px"}}
          rowKey="key"
          pagination={false}
          dataSource={[...Array(shimmerRows)].map((_, index) => ({
            key: `key${index}`,
          }))}
          showHeader={showHeader}
          columns={header.map((column) => {
            return {
              ...column,
              render: function renderPlaceholder() {
                return (
                  <Skeleton
                    key={column.key}
                    title
                    active={true}
                    paragraph={false}
                    height={50}
                    style={{ marginTop: "10px", width: "100%" }}
                  />
                );
              },
            };
          })}
          scroll={{ x: scroll }}
        />
      </TableStyle>) : (
        <Table
        style={{minHeight: minHeight ? minHeight : "380px"}}
        rowKey="key"
        pagination={false}
        dataSource={[...Array(shimmerRows)].map((_, index) => ({
          key: `key${index}`,
        }))}
        showHeader={showHeader}
        columns={header.map((column) => {
          return {
            ...column,
            render: function renderPlaceholder() {
              return (
                <Skeleton
                  key={column.key}
                  title
                  active={true}
                  paragraph={false}
                  height={50}
                  style={{ marginTop: "10px", width: "100%" }}
                />
              );
            },
          };
        })}
        scroll={{ x: scroll }}
      />
    )
  );
};

export default TableShimmer;
